import React from 'react';
import { getInitials } from '../utils/equipe2Helpers';

export function CoordinatorAvatar({ name, photoUrl, color, size = 36 }) {
  const radius = size > 34 ? 11 : 10;

  if (photoUrl) {
    return (
      <div
        className="equipe2-coord-avatar equipe2-coord-avatar--photo"
        style={{ width: size, height: size, borderRadius: radius }}
      >
        <img src={photoUrl} alt="" />
      </div>
    );
  }

  return (
    <div
      className="equipe2-coord-avatar"
      style={{
        width: size,
        height: size,
        borderRadius: radius,
        background: color.soft,
        color: color.strong,
      }}
    >
      {getInitials(name)}
    </div>
  );
}
